import { HomePagePath } from '@router/constants';
import { Navigate } from 'react-router-dom';

export const NotFoundPage = () => {
    return <Navigate to={HomePagePath} replace />;
};
